module.exports = __webpack_public_path__ + "static/fonts/DejaVuSansMono-BoldOblique.ca84e57.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/fonts/DejaVu/DejaVuSansMono-BoldOblique.ttf?v=1.1
// module id = 1644
// module chunks = 28